import React, { useRef } from "react";
import styled from "styled-components";
import picker from "../../assets/dropper.svg";
import save from "../../assets/saveIcon.svg";
import upload from "../../assets/upload.svg";
import Select from "../helpers/Select";

const EditorMenu = (props) => {
  const { showPicker, setVisiblity } = props;
  const inputEl = useRef(null);
  return (
    <Container>
      <ItemHolder>
        <ColorPicker
          showicon={showPicker}
          type="color"
          color={props.color}
          onClick={(e) => {
            setVisiblity();
          }}
        ></ColorPicker>
        <ItemName>Color</ItemName>
      </ItemHolder>

      <ItemHolder>
        <Select change={props.changeHandler} />
        <ItemName>Font</ItemName>
      </ItemHolder>

      <ItemHolder>
        <Row>
          <SmallFont onClick={() => props.changeHandler("fontSize", "12px")}>
            R
          </SmallFont>
          <MediumFont onClick={() => props.changeHandler("fontSize", "14px")}>
            R
          </MediumFont>
          <LargeFont onClick={() => props.changeHandler("fontSize", "16px")}>
            R
          </LargeFont>
        </Row>
        <ItemName>Size</ItemName>
      </ItemHolder>

      <ItemHolder onClick={props.saveData}>
        <Row>
          <Image src={save} alt="saveIcon" />
        </Row>
        <ItemName>Save</ItemName>
      </ItemHolder>

      <ItemHolder onClick={() => inputEl.current.click()}>
        <Row>
          <UploadData
            onChange={(e) => props.loadData(e)}
            ref={inputEl}
            type="file"
          />
          <Image src={upload} alt="uploadIcon" />
        </Row>
        <ItemName>Load Data</ItemName>
      </ItemHolder>

      {showPicker && (
        <ColorPopUp>
          <ColorCircle
            color="#716571"
            onClick={() => props.setColor("color", "#716571")}
          />
          <ColorCircle
            color="#3b3740"
            onClick={() => props.setColor("color", "#3b3740")}
          />
          <ColorCircle
            color="#328024"
            onClick={() => props.setColor("color", "#328024")}
          />
          <ColorCircle
            color="#512e63"
            onClick={() => props.setColor("color", "#512e63")}
          />
          <ColorCircle
            color="#663399"
            onClick={() => props.setColor("color", "#663399")}
          />
          <ColorInputWrapper image={picker} color="grey">
            <ColorInput
              type="color"
              value={props.color}
              onChange={(e) => props.setColor("color", e.target.value)}
            />
          </ColorInputWrapper>
        </ColorPopUp>
      )}
    </Container>
  );
};
export default EditorMenu;

const Container = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  background: #e9e5ec;
  border-radius: 5px;
  box-shadow: 0 3px 5px rgba(0, 0, 0, 0.2);
  height: 70px;
  width: fit-content;
  margin-bottom: 40px;
  animation: fadein 2s;
  @keyframes fadein {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;
const ColorPicker = styled.div`
  border-radius: 50%;
  height: 30px;
  width: 30px;
  background-color: ${(props) => props.color};
  margin: 0 8px;
  border: 2px solid #3b3740;
  &:hover {
    border: 2px solid white;
  }

  ${(props) =>
    props.showicon &&
    `
      background-image: url(https://image.flaticon.com/icons/svg/51/51517.svg);
      background-size: cover;
      text-align: center;
      font-family: sans-serif;
      color:red
    `}
`;

const ColorPopUp = styled.div`
  opacity: 1;
  transform: rotateX(0) translateX(-50%) translateY(0);
  transition-delay: 0.1s;
  position: absolute;
  background: #fff;
  padding: 22px 15px;
  box-shadow: 0 0 35px 0 rgba(0, 0, 0, 0.2);
  left: 50%;
  transform: translateX(-631%) translateY(18rem);
  top: 18px;
  height: fit-content;
  width: fit-content;
  border-radius: 16px;
  transition: all 0.3s ease;
  z-index: 9999999;
  cursor: default;

  &::before {
    width: 16px;
    height: 16px;
    top: -5px;
    margin-left: -8px;
    -webkit-transform: rotate(135deg);
    transform: rotate(135deg);
    content: "";
    position: absolute;
    background: #fff;
    left: 50%;
  }
  & > * {
    margin-bottom: 15px;
  }
  &:last-child {
    margin-bottom: 0;
  }
`;

const ColorCircle = styled.div`
  border-radius: 50%;
  width: 30px;
  height: 30px;
  background-color: ${(props) => props.color};
  border: 2px solid #3b3740;
  &:hover {
    border: 2px solid white;
  }
`;

const ColorInputWrapper = styled.div`
  border-radius: 50%;
  width: 30px;
  height: 30px;
  background-color: grey;
  background-image: url(${picker});
  background-position: center;
  background-size: 24px;
  border: 2px solid #3b3740;
`;

const ColorInput = styled.input`
  appearance: none;
  -webkit-appearance: none;
  cursor: pointer;
  height: 30px;
  width: 30px;
  opacity: 0;
  border-radius: 0;
`;

const ItemHolder = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  margin-left: 6px;
  margin-right: 6px;
`;

const ItemName = styled.span`
  text-align: center;
  font-size: 14px;
  font-weight: 700;
  color: rebeccapurple;
  line-height: 10px;
  margin-top: 5px;
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  height: 34px;
  justify-content: center;
`;

const Image = styled.img`
  height: 31px;
  cursor: pointer;
`;

const FontLabel = styled.div`
  display: flex;
  align-items: flex-end;
  color: grey;
  font-weight: 600;
  padding: 0 0.5rem;
  transition: color 0.2s ease;
  cursor: pointer;
  &:hover {
    color: rebeccapurple;
  }
`;

const SmallFont = styled(FontLabel)`
  font-size: 20px;
  line-height: 20px;
`;

const MediumFont = styled(FontLabel)`
  font-size: 35px;
  line-height: 29px;
`;

const LargeFont = styled(FontLabel)`
  font-size: 45px;
  line-height: 36px;
`;

const UploadData = styled.input`
  display: none;
`;
